/**
 * @license
 * Copyright Alibaba.com All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://github.com/NG-ZORRO/ng-zorro-antd/blob/master/LICENSE
 */

export default {
  // Options.jsx
  items_per_page: '/ à²ªà³à²',
  jump_to: 'à²à²¿à²à²¿à²¤à²µà²¨à³à²¨à³',
  jump_to_confirm: 'à²à²à²¿à²¤à²ªà²¡à²¿à²¸à²²à³ à²à²¿à²à²¿à²¤à²µà²¨à³à²¨à³',
  page: '',

  // Pagination.jsx
  prev_page: 'à²¹à²¿à²à²¦à²¿à²¨ à²ªà³à²',
  next_page: 'à²®à³à²à²¦à²¿à²¨ à²ªà³à²',
  prev_5: 'à²¹à²¿à²à²¦à²¿à²¨ 5 à²ªà³à²à²à²³à³',
  next_5: 'à²®à³à²à²¦à²¿à²¨ 5 à²ªà³à²à²à²³à³',
  prev_3: 'à²¹à²¿à²à²¦à²¿à²¨ 3 à²ªà³à²à²à²³à³',
  next_3: 'à²®à³à²à²¦à²¿à²¨ 3 à²ªà³à²à²à²³à³'
};
